import { useParams, Link, useNavigate } from 'react-router-dom';
import { edibleOilsData, getOilById, oilCategoryLabels } from '../data/edibleOilsData';
import { ChevronRight, ChevronDown, Droplets, Globe, Utensils, Languages, MessageSquareQuote, FlaskConical, Heart, Package } from 'lucide-react';
import { useState } from 'react';

// AI-Generated high-resolution images for edible oils
const oilImages = {
  'groundnut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1cef593f22e6d24e5ac20965ddf1d86a40b283753ae6cfb6af29c368b8610296.png',
  'sesame-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/890e914726ad218ad56978dffd0c5de7e1a74233fd93f3bb59365dd2731763c9.png',
  'mustard-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/0805c1a056e56f47ee1cdad4acd291f46917502118944af0b60d5989ca398b04.png',
  'coconut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/408f463b0af418974e800bdda4e158fbce7114be6c581d5233196a694add95d9.png',
  'sunflower-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/b0de4ba437023dbe4aa95ad3c2bcb7e04fe5e0508e9c5179650b4fac0ee086c7.png',
  'soybean-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/526074fa569997b41f081183579ba14f7802b13f956a7a0a29fa5d66c66b8deb.png',
  'rice-bran-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/98a1c8e86d72f225e7d1e6297a9d712ba5d7b4c5e0a222eb65d7cef2293a4163.png',
  'safflower-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/5aae194828f2c00ca77886a9bb9e0960bc786b99cf9c1487812a7f7db0ad0181.png',
  'cottonseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/53dd411097729d29251d16a715160522dc8f44df76f955a0c012849179011daf.png',
  'palm-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/60f72805fd9a45e496c424039b456177c86390133e59179747d8ba11f8ffabab.png',
  'castor-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/2c6948adc466552aa602d6021b8ecbc7a8473012ea60d8a4f3ac042045fece28.png',
  'linseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/43083a976183b98aea78bfa761eeb8508377e3f6bd4353de8ff684a1b7c9290e.png',
  'niger-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6b3d2ee467a1bc7ce6788cc38376fc37bbc41a73f183305c4d7f252e8b6eef30.png',
  'olive-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/d151e52bf6aaacd516678042204e23df8a464c8de5c39856e41dea329e3c649f.png',
  'corn-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7a20643e96143cb2e556db2a65af15929f7373f063b8dd5509574db1693016f5.png',
  'rapeseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/bf1a703fca7666d4b830ed3127d3c5c7785152103e527b7276ea7083a8e8c2da.png',
  'ghee': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ba5ecfde5fd740b840d2a434224229e453fb85da287e6024f1cefa6497babc7f.png',
  'butter': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ceedcf5593f3fbcb20ad00e34eaa1cef355561df9e27cef981d8cba94ea80e07.png',
  'avocado-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/d0ca01d4bad8b0cdc2989988580169ac9b162ac3c537e59100164341bffc5f2e.png',
  'walnut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4b2a5405aa0f261bddb66878205fd712ebf12f4d3c425a38bc07889c73f2e6a5.png',
  'almond-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07d9d638e4d6305a9919b68dd7664a41b6f04bbd37d7ed5840a3dd6294668c05.png',
};

const getOilImage = (imageKey) => {
  return oilImages[imageKey] || 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=800&h=500&fit=crop';
};

export default function EdibleOilDetail() {
  const { oilId } = useParams();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const oil = getOilById(oilId);

  if (!oil) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-700 mb-4">Product Not Found</h1>
          <Link to="/products/edible-oils" className="text-[#F47D20] hover:underline">
            Return to Edible Oils Catalogue
          </Link>
        </div>
      </div>
    );
  }

  const handleOilChange = (newOilId) => {
    setIsDropdownOpen(false);
    navigate(`/products/edible-oils/${newOilId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-8 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products/edible-oils" className="hover:text-[#F47D20] transition-colors">Edible Oils & Fats</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">{oil.name}</span>
          </nav>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={getOilImage(oil.image)}
                  alt={oil.name}
                  className="w-full h-64 md:h-80 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1.5 bg-[#F47D20] text-white text-sm font-medium rounded-full">
                  {oilCategoryLabels[oil.category]}
                </div>
              </div>
            </div>

            {/* Title and Quick Info */}
            <div className="w-full lg:w-1/2">
              {/* Oil Dropdown Selector */}
              <div className="relative mb-6">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center justify-between w-full md:w-80 px-4 py-3 bg-white/10 backdrop-blur border border-white/20 rounded-lg text-left hover:bg-white/20 transition-colors"
                  data-testid="oil-dropdown-toggle"
                >
                  <span className="text-sm">Browse Other Products</span>
                  <ChevronDown className={`w-5 h-5 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-full md:w-80 max-h-64 overflow-y-auto bg-white rounded-lg shadow-xl z-50 border border-gray-200">
                    {edibleOilsData.map((o) => (
                      <button
                        key={o.id}
                        onClick={() => handleOilChange(o.id)}
                        className={`w-full px-4 py-2.5 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between ${
                          o.id === oil.id ? 'bg-[#F47D20]/10 text-[#F47D20]' : 'text-gray-700'
                        }`}
                      >
                        <span>{o.name}</span>
                        {o.id === oil.id && <span className="text-xs">Current</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <h1 className="text-4xl md:text-5xl font-bold mb-2">{oil.name}</h1>
              <p className="text-xl text-gray-300 italic mb-6">{oil.botanicalName}</p>
              
              {/* Quick Info Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Family</div>
                  <div className="font-semibold">{oil.family}</div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Source</div>
                  <div className="font-semibold">{oil.source}</div>
                </div>
              </div>

              {/* Get Quote Button */}
              <Link
                to={`/contact?product=${encodeURIComponent(oil.name)}&type=Quote%20Request`}
                className="inline-flex items-center px-6 py-3 bg-[#F47D20] text-white font-semibold rounded-lg hover:bg-[#e06d10] transition-colors shadow-lg"
                data-testid="get-quote-btn"
              >
                <MessageSquareQuote className="w-5 h-5 mr-2" />
                Get Quote for {oil.name}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Description */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#263776]/10 rounded-lg flex items-center justify-center">
                  <Droplets className="w-5 h-5 text-[#263776]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Description</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{oil.description}</p>
            </section>

            {/* Extraction Method */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#F47D20]/10 rounded-lg flex items-center justify-center">
                  <FlaskConical className="w-5 h-5 text-[#F47D20]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Extraction & Processing</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{oil.extraction}</p>
            </section>

            {/* Uses */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Utensils className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Applications & Uses</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{oil.uses}</p>
            </section>

            {/* Health Benefits */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                  <Heart className="w-5 h-5 text-red-500" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Health Benefits</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{oil.healthBenefits}</p>
            </section>

            {/* Nutritional Profile */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Globe className="w-5 h-5 text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Nutritional Profile</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{oil.nutritionalProfile}</p>
            </section>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Specifications */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Package className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Specifications</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(oil.specifications).map(([key, value]) => (
                  <div key={key} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}</span>
                    <span className="font-medium text-gray-800 text-sm">{value}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* Indian Names */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                  <Languages className="w-5 h-5 text-orange-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Indian Names</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(oil.indianNames).map(([lang, name]) => (
                  <div key={lang} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm">{lang}</span>
                    <span className="font-medium text-gray-800 text-sm">{name}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* Storage Info */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-lg font-bold text-[#263776] mb-3">Storage & Shelf Life</h2>
              <p className="text-gray-600 text-sm leading-relaxed">{oil.storageShelfLife}</p>
            </section>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-[#263776] to-[#1e2d5f] rounded-xl p-6 text-white">
              <h3 className="text-lg font-bold mb-3">Interested in {oil.name}?</h3>
              <p className="text-gray-300 text-sm mb-4">
                Get competitive pricing, bulk quantities, and custom specifications for your business needs.
              </p>
              <Link
                to={`/contact?product=${encodeURIComponent(oil.name)}&type=Quote%20Request`}
                className="block w-full py-3 bg-[#F47D20] text-center font-semibold rounded-lg hover:bg-[#e06d10] transition-colors"
                data-testid="sidebar-get-quote-btn"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products */}
      <div className="bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#263776] mb-6">Related Products</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {edibleOilsData
              .filter(o => o.id !== oil.id && o.category === oil.category)
              .slice(0, 6)
              .map((relatedOil) => (
                <Link
                  key={relatedOil.id}
                  to={`/products/edible-oils/${relatedOil.id}`}
                  className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all"
                >
                  <div className="h-24 overflow-hidden">
                    <img
                      src={getOilImage(relatedOil.image)}
                      alt={relatedOil.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-medium text-sm text-[#263776] group-hover:text-[#F47D20] transition-colors truncate">
                      {relatedOil.name}
                    </h3>
                  </div>
                </Link>
              ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/products/edible-oils"
              className="inline-flex items-center px-6 py-3 border-2 border-[#263776] text-[#263776] font-semibold rounded-lg hover:bg-[#263776] hover:text-white transition-colors"
            >
              View Full Catalogue
              <ChevronRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
